<template>
<div class="item">

  <b-card class="item-card shadow"
          no-body>

    <div class="actions top">
      <CloseButton @close="close()" />

      <h2>{{section.single}}</h2>

      <div class="extraInfo uppercaseheader">
        <div>{{asShortDate(item.created)}}</div>
      </div>
    </div>

    <div class="fields">
      <Input v-for="field in allFields"
             :key="field.id"
             :field="field"
             :item="item"
             :section="section" />
    </div>

    <div class="actions bottom">
      <b-button @click="remove()"
                variant="danger"
                size="sm">Delete</b-button>

    </div>

  </b-card>

</div>
</template>

<script>
// Firebase
const firebase = require( '@/firebaseConfig.js' )
//Models
const Provider = require( '@/models/Provider.js' )
const Project = require( '@/models/Project.js' )
const Client = require( '@/models/Client.js' )
const Skill = require( '@/models/Skill.js' )
const Preference = require( '@/models/Preference.js' )
const Goal = require( '@/models/Goal.js' )
//Components
import Input from '@/components/admin/Input'
import CloseButton from '@/components/CloseButton'
// Mixins
import { Formatter, Skills, Status } from '@/mixins/Mixins.js'
export default {
  name: 'ProviderItem',
  components: {
    CloseButton,
    Input,
  },
  mixins: [ Formatter, Skills, Status ],
  props: {
    item: Object,
    section: Object,
  },
  data() {
    return {}
  },
  computed: {
    allFields() {
      switch ( this.section.id ) {
        case 'providers':
          return Provider.fields
        case 'clients':
          return Client.fields
        case 'projects':
          return Project.fields
        case 'skills':
          return Skill.fields
        case 'preferences':
          return Preference.fields
        case 'goals':
          return Goal.fields
        default:
          return false
      }
    }
  },
  methods: {
    remove() {
      firebase.db.collection( this.section.db )
        .doc( this.item.id )
        .delete().then( () => {
          this.close()
        } )
    },
    close() {
      this.$emit( 'close' )
    },
    options( list ) {
      return this[ list ]
    },
  },
}
</script>


<style scoped lang="scss">
@import "@/styles/global.scss";

.item {
    display: grid;
    align-items: center;

    .item-card {
        padding: 0;
        display: grid;
        grid-row-gap: 1rem;
    }

    .fields {
        font-family: 'Roboto';
        display: grid;
    }

    .actions {
        display: grid;
        grid-auto-flow: column;
        align-items: center;
        align-content: center;
        grid-column-gap: 1rem;
        padding: 2rem;

        &.top {
            grid-template-columns: auto 1fr;
            align-items: center;

            .extraInfo {
                color: theme-color-level('primary',-8);
                display: grid;
                grid-row-gap: 0.3rem;
            }
        }

        &.bottom {
            justify-content: flex-end;
        }
    }

}
</style>
